<template>
  <el-main>
    <div class="mybread">
      <p><i class="el-icon-location"></i>当前位置：</p>
      <el-breadcrumb separator-class="el-icon-arrow-right">
        <el-breadcrumb-item>客户项目</el-breadcrumb-item>
        <el-breadcrumb-item>支付管理</el-breadcrumb-item>
      </el-breadcrumb>
    </div>

    <div class="form">
      <el-form ref="form" label-width="120px" label-position="left">
        <el-form-item label="" style="margin-left: -120px;">
          <el-col :span="5">
            <el-select v-model="form.atype" placeholder="请选择类别" style="margin-right: 0; width: 100%;">
              <el-option label="项目名称" value="contract_name"></el-option>
              <el-option label="合同编号" value="contract_no"></el-option>
              <el-option label="客户公司名称" value="client_company"></el-option>
              <el-option label="品牌" value="brand"></el-option>
              <!-- <el-option label="支出明细名称" value="pay_info"></el-option> -->
              <el-option label="支付计划名称" value="plan_name"></el-option>
              <el-option label="供应商名称" value="vendor"></el-option>
              <el-option label="服务说明" value="service_info"></el-option>
            </el-select>
          </el-col>
          <el-col :span="12" style="margin-right: 10px;">
            <el-input placeholder="请输入内容" v-model="form.key" @keyup.enter.native="search" clearable @clear="search">
            </el-input>
          </el-col>
          <el-col :span="2">
            <el-button type="primary" icon="el-icon-search" @click="search">搜索</el-button>
          </el-col>
        </el-form-item>

        <el-form-item label="计划支付时间：" prop="time">
          <el-col :span="12">
            <el-date-picker v-model="form.hope_pay_time" type="datetimerange" range-separator="--"
              start-placeholder="期望开始支付日期" end-placeholder="期望结束支付日期" style="width: 58%;margin-right: 10px;"
              @change="search(false)">
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item label="支付时间：" prop="time">
          <el-col :span="12">
            <el-date-picker v-model="form.pay_time" type="datetimerange" range-separator="--" start-placeholder="开始支付日期"
              end-placeholder="结束支付日期" style="width: 58%;margin-right: 10px;" @change="search(false)">
            </el-date-picker>
          </el-col>
        </el-form-item>

        <el-form-item label="申请金额：" prop="apply_amount">
          <el-col :span="3">
            <el-input placeholder="请输入" maxlength="100" v-model="form.apply_amount_from" clearable style="width: 100%;"
              @blur="applySearch" />
          </el-col>
          <el-col :span="1">
            <div style="width: 100%; text-align: center;"> — </div>
          </el-col>
          <el-col :span="3">
            <el-input placeholder="请输入" maxlength="100" v-model="form.apply_amount_to" clearable style="width: 100%;"
              @blur="applySearch" />
          </el-col>
        </el-form-item>

        <el-form-item label="发票金额：" prop="invoice_amount">
          <el-col :span="3">
            <el-input placeholder="请输入" maxlength="100" v-model="form.invoice_amount_from" clearable
              style="width: 100%;" @blur="invoiceSearch" />
          </el-col>
          <el-col :span="1">
            <div style="width: 100%; text-align: center;"> — </div>
          </el-col>
          <el-col :span="3">
            <el-input placeholder="请输入" maxlength="100" v-model="form.invoice_amount_to" clearable style="width: 100%;"
              @blur="invoiceSearch" />
          </el-col>
        </el-form-item>

        <el-form-item label="更多" prop="type">
          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.service_type" placeholder="选择服务类目" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option :label="item.category_name" :value="item.id" v-for="(item, index) in ServiceTileList" :key="`sev_${index}`"></el-option>
            </el-select>
          </el-col>

          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.pay_type" placeholder="选择支付类别" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="正常" value="1"></el-option>
              <el-option label="预支" value="2"></el-option>
            </el-select>
          </el-col>

          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.vendor_contract_status" placeholder="供应商合同状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="未申请" value="4"></el-option>
              <el-option label="已申请" value="1"></el-option>
              <el-option label="已获取编号" value="2"></el-option>
              <el-option label="已盖章" value="3"></el-option>
              <el-option label="未选择合同" value="5"></el-option>
              <el-option label="无需合同" value="6"></el-option>
            </el-select>
          </el-col>

          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.budget_status" placeholder="预算审核状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="未提交" value="1"></el-option>
              <el-option label="待审核" value="2"></el-option>
              <el-option label="审核通过" value="3"></el-option>
              <el-option label="审核不通过" value="4"></el-option>
            </el-select>
          </el-col>

          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.pay_check_status" placeholder="支付审核状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="未申请" value="1"></el-option>
              <el-option label="待审核" value="2"></el-option>
              <el-option label="审核通过" value="3"></el-option>
              <el-option label="审核不通过" value="4"></el-option>
            </el-select>
          </el-col>

          <el-col :span="3" style="margin-right: 20px;">
            <el-select v-model="form.pay_status" placeholder="支付状态" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option label="未支付" value="1"></el-option>
              <el-option label="已支付" value="3"></el-option>
            </el-select>
          </el-col>

          <el-col :span="3">
            <el-select v-model="form.year" placeholder="项目认列年份" style="margin-right: 0; width: 100%;"
              @change="search(false)">
              <el-option :label="v" :value="v" v-for="(v, i) in yearList" :key="i"></el-option>
            </el-select>
          </el-col>

        </el-form-item>

        <el-form-item label="已选条件">
          <el-tag v-for="tag in tags" :key="tag.key" effect="dark" closable @close="removeTag(tag)">
            {{ tag.key }}: {{ tag.value }}
          </el-tag>
        </el-form-item>
      </el-form>
    </div>

    <div class="table">
      <div class="filterwrap">
        <div class="filter">
          <el-checkbox-group class="filtergroup" v-model="checkList" prop="checkList" :min="5">
            <el-checkbox label="客户合同编号"></el-checkbox>
            <el-checkbox label="客户公司名称"></el-checkbox>
            <el-checkbox label="品牌"></el-checkbox>
            <el-checkbox label="项目名称"></el-checkbox>
            <el-checkbox label="子项目名称"></el-checkbox>
            <el-checkbox label="服务类目"></el-checkbox>
            <el-checkbox label="服务说明"></el-checkbox>
            <el-checkbox label="供应商合同编号"></el-checkbox>
            <el-checkbox label="供应商名称"></el-checkbox>
            <el-checkbox label="支付计划名称"></el-checkbox>
            <el-checkbox label="支付类别"></el-checkbox>
            <el-checkbox label="预算"></el-checkbox>
            <el-checkbox label="成本"></el-checkbox>
            <el-checkbox label="计划支付时间"></el-checkbox>
            <el-checkbox label="计划支付金额"></el-checkbox>
            <el-checkbox label="已收发票"></el-checkbox>
            <el-checkbox label="未收发票"></el-checkbox>
            <el-checkbox label="已支付"></el-checkbox>
            <el-checkbox label="未支付"></el-checkbox>
            <el-checkbox label="支付时间"></el-checkbox>
            <el-checkbox label="供应商合同状态"></el-checkbox>
            <el-checkbox label="预算审核状态"></el-checkbox>
            <el-checkbox label="支付审核状态"></el-checkbox>
            <el-checkbox label="支付状态"></el-checkbox>
            <el-checkbox label="项目负责人"></el-checkbox>
          </el-checkbox-group>
        </div>
        <div class="btnarea">
          <el-button @click="_exportPayToExcel" v-if="NodeInclude('106')">按支出导出数据</el-button>
          <el-button @click="exportPayToExcel"  v-if="NodeInclude('105')">导出数据</el-button>
        </div>
      </div>

      <el-table :data="itemList" border stripe style="width: 100%;" highlight-current-row>
        <el-table-column prop="contract_no" label="客户合同编号" header-align="center" align="center" width="150"
          v-if="check('客户合同编号')">
          <template slot-scope="scope">
            <div class="linkwrap normal">
              <el-link type='primary' class="link"
                @click="link(scope.row.projectPayArr ? `/project/detail?id=${scope.row.projectPayArr.projectArr.id}` : '')">{{
                  scope.row.projectPayArr ? (scope.row.projectPayArr.projectArr.contract_no ?
                    scope.row.projectPayArr.projectArr.contract_no : '暂无') : '' }}</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="client_company" label="客户公司名称" header-align="center" align="center" width="200"
          v-if="check('客户公司名称')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.projectPayArr.projectArr.client_company : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="brand" label="品牌" header-align="center" align="center" width="150"
          v-if="check('品牌')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.projectPayArr.projectArr.brand : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="contract_name" label="项目名称" header-align="center" align="center" width="200"
          v-if="check('项目名称')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.projectPayArr.projectArr.contract_name : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="son_contract_name" label="子项目名称" header-align="center" align="center" width="200"
          v-if="check('子项目名称')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.projectPayArr.projectSonArr.contract_name : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="vendor_service_type" label="服务类目" header-align="center" align="center" width="100"
          v-if="check('服务类目')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.projectPayArr.service_type_name : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="vendor_service_info" label="服务说明" header-align="center" align="left" width="400"
          v-if="check('服务说明')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.projectPayArr.service_info : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="vendor_contract_name" label="供应商合同编号" header-align="center" align="center"
          width="150" v-if="check('供应商合同编号')">
          <template slot-scope="scope">
            <div v-if="scope.row.projectPayArr.contract_id == '-1'">无需合同</div>
            <div class="linkwrap normal" v-else>
              <el-link type='primary' class="link"
                @click="link(scope.row.projectPayArr ? `/purchase/view?id=${scope.row.projectPayArr.vendorContractArr.id}` : '')"
                v-if="scope.row.projectPayArr.vendorContractArr">{{ scope.row.projectPayArr ?
                  (scope.row.projectPayArr.vendorContractArr ? scope.row.projectPayArr.vendorContractArr.contract_no :
                    '暂无')
                : '' }}</el-link>
              <el-link type='primary' class="link" @click="showWrongFn('请先选择对应的供应商合同')" v-else>暂无</el-link>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="vendor" label="供应商名称" header-align="center" align="center" width="200"
          v-if="check('供应商名称')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? (scope.row.projectPayArr.vendorArr.vendor ?
              scope.row.projectPayArr.vendorArr.vendor : '暂无') : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="hope_pay_time" label="支付计划名称" header-align="center" align="center" width="120"
          v-if="check('支付计划名称')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.plan_name : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="hope_pay_time" label="支付类别" header-align="center" align="center" width="120"
          v-if="check('支付类别')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? dd.pay_type[scope.row.projectPayArr.pay_type] : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="budget" label="预算" header-align="center" align="right" width="100"
          v-if="check('预算')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.projectPayArr.budget : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="cost" label="成本" header-align="center" align="right" width="100" v-if="check('成本')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.projectPayArr.cost : '暂无' }}
          </template>
        </el-table-column>
        <el-table-column prop="plan_amount" label="计划支付金额" header-align="center" align="right" width="100"
          v-if="check('计划支付金额')">
          <template slot-scope="scope">
            {{ scope.row.plan_amount }}
          </template>
        </el-table-column>
        <el-table-column prop="hope_pay_time" label="计划支付时间" header-align="center" align="center" width="120"
          v-if="check('计划支付时间')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.hope_pay_time : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="payed" label="已收发票" header-align="center" align="right" width="100"
          v-if="check('已收发票')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.projectPayArr.vendorTotalInvoice : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="payed" label="未收发票" header-align="center" align="right" width="100"
          v-if="check('未收发票')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.projectPayArr.vendorTotalUnInvoice : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="payed" label="已支付" header-align="center" align="right" width="100"
          v-if="check('已支付')">
          <template slot-scope="scope">
            {{ scope.row.pay_status == 3 ? scope.row.plan_amount : '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="nopay" label="未支付" header-align="center" align="right" width="100"
          v-if="check('未支付')">
          <template slot-scope="scope">
            {{ scope.row.pay_status == 1 ? scope.row.plan_amount : '0.00' }}
          </template>
        </el-table-column>
        <el-table-column prop="pay_time" label="支付时间" header-align="center" align="center" width="120"
          v-if="check('支付时间')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.pay_time : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="brandStr" label="供应商合同状态" header-align="center" align="center" width="120"
          v-if="check('供应商合同状态')">
          <template slot-scope="scope">
            <div class="circle-tag" :style="{ 'background': dd.pruchase_contract_status_c[6].color }"
              v-if="scope.row.projectPayArr.contract_id == '-1'">
              <div class="word">{{ dd.pruchase_contract_status_c[6].word }}</div>
            </div>
            <template v-else>
              <div class="circle-tag" :style="{ 'background': dd.pruchase_contract_status_c[5].color }"
                v-if="!scope.row.projectPayArr.vendorContractArr">
                <div class="word">{{ dd.pruchase_contract_status_c[5].word }}</div>
              </div>
              <div class="circle-tag"
                :style="{ 'background': scope.row.projectPayArr.vendorContractArr.status == '1' ? (scope.row.projectPayArr.vendorContractArr.is_apply == '1' ? dd.pruchase_contract_status_c[4].color : dd.pruchase_contract_status_c[1].color) : dd.pruchase_contract_status_c[scope.row.projectPayArr.vendorContractArr.status].color }"
                v-else>
                <div class="word">{{ scope.row.projectPayArr.vendorContractArr.status == '1' ?
                  (scope.row.projectPayArr.vendorContractArr.is_apply == '1' ? dd.pruchase_contract_status_c[4].word :
                    dd.pruchase_contract_status_c[1].word) :
                  dd.pruchase_contract_status_c[scope.row.projectPayArr.vendorContractArr.status].word }}</div>
              </div>
            </template>
          </template>
        </el-table-column>
        <el-table-column prop="budget_status" label="预算审核状态" header-align="center" align="center" width="100"
          v-if="check('预算审核状态')">
          <template slot-scope="scope">
            <div class="circle-tag"
              :style="{ 'background': dd.budget_status_c[scope.row.projectPayArr.budget_status].color }">
              <div class="word">{{ dd.budget_status_c[scope.row.projectPayArr.budget_status].word }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="pay_check_status" label="支付审核状态" header-align="center" align="center" width="100"
          v-if="check('支付审核状态')">
          <template slot-scope="scope">
            <div class="circle-tag" :style="{ 'background': dd.pay_check_status_c[scope.row.pay_check_status].color }">
              <div class="word">{{ dd.pay_check_status_c[scope.row.pay_check_status].word }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="pay_status" label="支付状态" header-align="center" align="center" width="80"
          v-if="check('支付状态')">
          <template slot-scope="scope">
            <div class="circle-tag" :style="{ 'background': dd.pay_status_c[scope.row.pay_status].color }">
              <div class="word">{{ dd.pay_status_c[scope.row.pay_status].word }}</div>
            </div>
          </template>
        </el-table-column>
        <el-table-column prop="manager_name" label="项目负责人" header-align="center" align="center" width="100"
          v-if="check('项目负责人')">
          <template slot-scope="scope">
            {{ scope.row.projectPayArr ? scope.row.projectPayArr.projectArr.manager_name : '' }}
          </template>
        </el-table-column>
        <el-table-column prop="" label="操作" header-align="center" align="center" min-width="350" fixed="right" v-if="NodeInclude('248') || NodeInclude('46') || NodeInclude('49') || NodeInclude('48') || NodeInclude('339') || NodeInclude('50') || NodeInclude('51') || NodeInclude('52')">
          <template slot-scope="scope">
            <div class="linkwrap">
              <span class="link" @click="delClick(scope.row)" v-show="NodeInclude('248')">删除</span>
              <el-link type='primary' class="link" @click="editClick(scope.row)" v-show="NodeInclude('46')">编辑</el-link>
              <span class="link" @click="applyPayClick(scope.row)"
                v-if="NodeInclude('49')">申请支付</span>
              <span class="link" @click="budgetCheckClick(scope.row)" v-show="NodeInclude('48') || NodeInclude('339')">预算审核</span>
              <span class="link" @click="payCheckClick(scope.row)" v-show="NodeInclude('50')">支付审核</span>
              <el-link type='primary' class="link" @click="updatePayClick(scope.row)" v-show="NodeInclude('51')">更新支付状态</el-link>
              <el-link type='primary' class="link" @click="viewClick(scope.row)" v-show="NodeInclude('52')">查看</el-link>
            </div>
          </template>
        </el-table-column>
      </el-table>
      <div class="lower" v-if="NodeInclude('100')">
        <div>预算合计：{{ total_item.total_budget }}</div>
        <div>成本合计：{{ total_item.total_cost }}</div>
        <div>计划支付金额合计：{{ total_item.total_plan_amount }}</div>
        <div>已收发票合计：{{ total_item.total_vendor_invoice }}</div>
        <div>未收发票合计：{{ total_item.total_vendor_uninvoice }}</div>
        <div>已支付合计：{{ total_item.total_paid_amount }}</div>
        <div>未支付合计：{{ total_item.total_unpaid_amount }}</div>
        <div>
          <el-button type="primary" @click="getPlanStatic()">更新合计</el-button>
        </div>
      </div>
      <div class="apage">
        <el-pagination @current-change="handleCurrentChange" :current-page="p" :page-size="30"
          layout="total, prev, pager, next, jumper" :total="total">
        </el-pagination>
      </div>
    </div>

    <el-dialog title="删除提醒" :visible.sync="delShow" width="800px" v-if="currDel">
      <ul class="aul" style="padding:0">
        <li>
          <label>温馨提示：</label>
          <span>您是否确定删除该预算</span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="delShow = false">取 消</el-button>
        <el-button type="primary" @click="handleDel">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="支付申请" :visible.sync="payShow" width="600px" v-if="currToPay">
      <ul class="aul ulist" style="padding:0">
        <li>
          <span>客户公司名称：</span>
          <span>{{ currToPay.projectPayArr ? currToPay.projectPayArr.projectArr.client_company : '' }}</span>
        </li>
        <li>
          <span>品牌：</span>
          <span>{{ currToPay.projectPayArr ? currToPay.projectPayArr.projectArr.brand : '' }}</span>
        </li>
        <li>
          <span>项目名称：</span>
          <span>{{ currToPay.projectPayArr ? currToPay.projectPayArr.projectArr.contract_name : '' }}</span>
        </li>
        <li>
          <span>子项目名称：</span>
          <span>{{ currToPay.projectPayArr ? currToPay.projectPayArr.projectSonArr.contract_name : '' }}</span>
        </li>
        <li>
          <span>服务类目：</span>
          <span>{{ currToPay.projectPayArr ? currToPay.projectPayArr.service_type_name : '' }}</span>
        </li>
        <li>
          <span>服务说明：</span>
          <span class="info-height">{{ currToPay.projectPayArr ? currToPay.projectPayArr.service_info : '' }}</span>
        </li>
        <li>
          <span>供应商名称：</span>
          <span>{{ currToPay.projectPayArr ? currToPay.projectPayArr.vendorArr.vendor : '' }}</span>
        </li>
        <li>
          <span>支付类别：</span>
          <span>{{ currToPay.projectPayArr ? dd.pay_type[currToPay.projectPayArr.pay_type] : '' }}</span>
        </li>
        <li>
          <span>供应商合同：</span>
          <span>{{ currToPay.vendorContractArr && (currToPay.vendorContractArr.fileList != []) ? '有' : '无' }}</span>
        </li>
        <li>
          <span>供应商发票合计金额：</span>
          <span> {{ currToPay.projectPayArr ? currToPay.projectPayArr.vendorTotalInvoice : '' }} </span>
        </li>
        <li>
          <span>项目验收：</span>
          <span> {{ currToPay.projectPayArr ? (currToPay.projectPayArr.check_info ? '已验收' : '未验收') : '' }} </span>
        </li>
        <li>
          <span>支付计划：</span>
          <span> {{ currToPay.plan_name }} </span>
        </li>
        <li>
          <span>计划支付时间：</span>
          <span> {{ currToPay.hope_pay_time }} </span>
        </li>
        <li>
          <span>计划付款金额：</span>
          <span> {{ currToPay.plan_amount }} </span>
        </li>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payShow = false">取 消</el-button>
        <el-button type="primary" @click="handleApply">申 请</el-button>
      </span>
    </el-dialog>

    <el-dialog title="预算审核" :visible.sync="budgetCheckShow" width="600px" v-if="currbudgetCheck">
      <ul class="aul ulist" style="padding:0">
        <li>
          <span>客户公司名称：</span>
          <span>{{ currbudgetCheck.projectPayArr ? currbudgetCheck.projectPayArr.projectArr.client_company : ''
            }}</span>
        </li>
        <li>
          <span>品牌：</span>
          <span>{{ currbudgetCheck.projectPayArr ? currbudgetCheck.projectPayArr.projectArr.brand : '' }}</span>
        </li>
        <li>
          <span>项目名称：</span>
          <span>{{ currbudgetCheck.projectPayArr ? currbudgetCheck.projectPayArr.projectArr.contract_name : '' }}</span>
        </li>
        <li>
          <span>子项目名称：</span>
          <span>{{ currbudgetCheck.projectPayArr ? currbudgetCheck.projectPayArr.projectSonArr.contract_name : ''
            }}</span>
        </li>
        <li>
          <span>服务类目：</span>
          <span>{{ currbudgetCheck.projectPayArr ? currbudgetCheck.projectPayArr.service_type_name : ''
            }}</span>
        </li>
        <li>
          <span>服务说明：</span>
          <span class="info-height">{{ currbudgetCheck.projectPayArr ? currbudgetCheck.projectPayArr.service_info : ''
            }}</span>
        </li>
        <li>
          <span>预算：</span>
          <span>{{ currbudgetCheck.projectPayArr ? currbudgetCheck.projectPayArr.budget : '' }}</span>
        </li>
        <li>
          <span>成本：</span>
          <span>{{ currbudgetCheck.plan_amount ? currbudgetCheck.plan_amount : '暂无' }}</span>
        </li>
        <li>
          <span>供应商名称：</span>
          <span>{{ currbudgetCheck.projectPayArr ? currbudgetCheck.projectPayArr.vendorContractArr.vendor : '' }}</span>
        </li>
        <li>
          <span>供应商合同金额：</span>
          <span>{{ currbudgetCheck.projectPayArr ? currbudgetCheck.projectPayArr.vendorContractArr.contract_amount : ''
            }}</span>
        </li>
        <el-form ref="bugetCheckForm" :model="bugetCheckForm" label-width="220px" label-position="left" class="ulform">
          <el-form-item label="选择支付计划：" prop="budget_status">
            <el-col :span="24">
              <el-radio-group v-model="bugetCheckForm.budget_status">
                <el-radio label="3">通过</el-radio>
                <el-radio label="4">不通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <template v-if="bugetCheckForm.budget_status == '3'">
            <el-form-item label="" prop="budget_check_info">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="bugetCheckForm.budget_check_info">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
          <template v-if="bugetCheckForm.budget_status == '4'">
            <el-form-item label="" prop="budget_check_reason">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="bugetCheckForm.budget_check_reason">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="budgetCheckShow = false">取 消</el-button>
        <el-button type="primary" @click="handleBudgetCheck">确 定</el-button>
      </span>
    </el-dialog>

    <el-dialog title="支付审核" :visible.sync="payCheckShow" width="600px" v-if="currPayCheck">
      <ul class="aul ulist" style="padding:0;">
        <li>
          <span>客户公司名称：</span>
          <span>{{ currPayCheck.projectPayArr ? currPayCheck.projectPayArr.projectArr.client_company : '' }}</span>
        </li>
        <li>
          <span>品牌：</span>
          <span>{{ currPayCheck.projectPayArr ? currPayCheck.projectPayArr.projectArr.brand : '' }}</span>
        </li>
        <li>
          <span>项目名称：</span>
          <span>{{ currPayCheck.projectPayArr ? currPayCheck.projectPayArr.projectArr.contract_name : '' }}</span>
        </li>
        <li>
          <span>子项目名称：</span>
          <span>{{ currPayCheck.projectPayArr ? currPayCheck.projectPayArr.projectSonArr.contract_name : '' }}</span>
        </li>
        <li>
          <span>服务类目：</span>
          <span>{{ currPayCheck.projectPayArr ? currPayCheck.projectPayArr.service_type_name : '' }}</span>
        </li>
        <li>
          <span>服务说明：</span>
          <span class="info-height">{{ currPayCheck.projectPayArr ? currPayCheck.projectPayArr.service_info : ''
            }}</span>
        </li>
        <li>
          <span>供应商名称：</span>
          <span>{{ currPayCheck.projectPayArr ? currPayCheck.projectPayArr.vendorContractArr.vendor : '' }}</span>
        </li>
        <li>
          <span>支付类别：</span>
          <span>{{ currPayCheck.projectPayArr ? dd.pay_type[currPayCheck.projectPayArr.pay_type] : '' }}</span>
        </li>
        <li>
          <span>供应商合同：</span>
          <span>{{ currPayCheck.projectPayArr && (currPayCheck.projectPayArr.vendorContractArr.fileList != []) ? '有'
            : '无' }}</span>
        </li>
        <li>
          <span>供应商发票合计金额：</span>
          <span> {{ currPayCheck.vendorTotalInvoice }} </span>
        </li>
        <li>
          <span>项目验收：</span>
          <span> {{ currPayCheck.projectPayArr ? (currPayCheck.projectPayArr.check_info ? '已验收' : '未验收') : '' }} </span>
        </li>
        <el-form ref="payCheckForm" :model="payCheckForm" label-width="220px" label-position="left" class="ulform">
          <el-form-item label="审核：" prop="pay_check_status">
            <el-col :span="24">
              <el-radio-group v-model="payCheckForm.pay_check_status">
                <el-radio label="3">通过</el-radio>
                <el-radio label="4">不通过</el-radio>
              </el-radio-group>
            </el-col>
          </el-form-item>
          <template v-if="payCheckForm.pay_check_status == '3'">
            <el-form-item label="" prop="pay_check_reason">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="payCheckForm.pay_check_info">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
          <template v-if="payCheckForm.pay_check_status == '4'">
            <el-form-item label="" prop="pay_check_reason">
              <el-col :span="24">
                <el-input type="textarea" spellcheck="false" :autosize="{ minRows: 4 }" placeholder="请输入内容"
                  v-model="payCheckForm.pay_check_reason">
                </el-input>
              </el-col>
            </el-form-item>
          </template>
        </el-form>
      </ul>
      <span slot="footer" class="dialog-footer">
        <el-button @click="payCheckShow = false">取 消</el-button>
        <el-button type="primary" @click="handlePayCheck">确 定</el-button>
      </span>
    </el-dialog>
  </el-main>
</template>

<script>
// CodeToText
import * as api from '@/api'
import { thousands, antiThousands } from '@/utils/index.js'
import store from '@/store'
export default {
  name: 'custom',
  data() {
    return {
      nodeLimtList: [],
      level: '',
      realName: '',
      checkList: [
        '客户合同编号',
        '客户公司名称',
        '品牌',
        '项目名称',
        '子项目名称',
        '服务类目',
        '服务说明',
        '供应商合同编号',
        '供应商名称',
        '支付计划名称',
        '支付类别',
        '预算',
        '成本',
        '计划支付时间',
        '计划支付金额',
        '已收发票',
        '未收发票',
        '已支付',
        '未支付',
        '支付时间',
        '供应商合同状态',
        '预算审核状态',
        '支付审核状态',
        '支付状态',
        '项目负责人',
      ],
      itemList: [],
      total: 0,
      perPage: 30,
      p: 1,
      form: {
        key: '',
        atype: 'contract_name',
        hope_pay_time: ['', ''],
        pay_time: ['', ''],
        apply_amount_from: undefined,
        apply_amount_to: undefined,
        invoice_amount_from: undefined,
        invoice_amount_to: undefined,
      },
      bugetCheckForm: {
        option: 2,
        pay_id: '',
        budget_status: '4',
        budget_check_info: '',
        budget_check_reason: '',
      },
      payCheckForm: {
        plan_id: '', pay_check_status: '4', pay_check_reason: '', pay_check_info: '',
      },
      payForm: {
        plan_id: '',
        hope_pay_time: '',
        plan_amount: ''
      },
      budgetCheckShow: false,
      currbudgetCheck: {//当前预算审核

      },
      payCheckShow: false,
      currPayCheck: {//当前支付审核

      },
      delShow: false,
      currDel: {//当前删除的数组

      },
      payShow: false,
      currToPay: {//当前支付申请数组

      },
      yearList: [],
      total_item: {},
			ServiceTileList: [],
    }
  },
  computed: {
    tags() {
      let temp = [
        {
          key: this.dd.payType[this.form.atype],
          val: 'atype',
          value: this.form.key,
          active: !!this.form.atype && !!this.form.key,
        },
        {
          key: '计划支付时间',
          val: 'hope_pay_time',
          value: this.dateValue(this.form.hope_pay_time),
          active: !!this.form.hope_pay_time && this.form.hope_pay_time[0] && !!this.form.hope_pay_time && this.form.hope_pay_time[1],
        },
        {
          key: '支付时间',
          val: 'pay_time',
          value: this.dateValue(this.form.pay_time),
          active: !!this.form.pay_time && this.form.pay_time[0] && !!this.form.pay_time && this.form.pay_time[1],
        },
        {
          key: '申请金额',
          val: 'apply_amount',
          value: this.form.apply_amount_from + '-' + this.form.apply_amount_to,
          active: !!this.form.apply_amount_from && !!this.form.apply_amount_to,
        },
        {
          key: '发票金额',
          val: 'invoice_amount',
          value: this.form.invoice_amount_from + '-' + this.form.invoice_amount_to,
          active: !!this.form.invoice_amount_from && !!this.form.invoice_amount_to,
        },
        {
          key: '服务类目',
          val: 'service_type',
          value: this.form.service_type_name,
          active: !!this.form.service_type,
        },
        {
          key: '支付类别',
          val: 'pay_type',
          value: this.dd.pay_type[this.form.pay_type],
          active: !!this.form.pay_type,
        },
        {
          key: '供应商合同状态',
          val: 'vendor_contract_status',
          value: this.dd.pruchase_contract_status[this.form.vendor_contract_status],
          active: !!this.form.vendor_contract_status,
        },
        {
          key: '预算审核状态',
          val: 'budget_status',
          value: this.dd.budget_status[this.form.budget_status],
          active: !!this.form.budget_status,
        },
        {
          key: '支付审核状态',
          val: 'pay_check_status',
          value: this.dd.pay_check_status[this.form.pay_check_status],
          active: !!this.form.pay_check_status,
        },
        {
          key: '支付状态',
          val: 'pay_status',
          value: this.dd.pay_status[this.form.pay_status],
          active: !!this.form.pay_status,
        },
        {
          key: '认列年份',
          val: 'year',
          value: this.form.year,
          active: !!this.form.year,
        },
      ]
      temp = temp.filter((item) => item.active)
      return temp
    },
  },
  created() {
    var date = new Date()
    var year = date.getFullYear() + 1
    this.getYearList(year);
  },
  mounted() {
    this.getStoreFn()
		this.getServiceTileList()
  },
  methods: {
    checkUrlFn() {
      // 获取当前URL的哈希部分  
      const hash = window.location.hash;  
      // 移除'#'字符  
      const url = hash.substring(1); 
      
      let postData = {
        url_path: url
      }
      api.checkLoginUrl(postData).then((res) => {
        if (res.status == 400) {
          this.$message({
            type: 'info',
            message: '暂无权限',
          })
          this.$router.push({
            path: `/home`
          });
        }
      })
    },
    checkNodeFn(menu_id) {
      let postData = {
        menu_id,
      }
      api.checkNode(postData).then((res) => {
        this.nodeLimtList = res.node_ids.split(',')
      })
    },
    NodeInclude(val) {
      return this.nodeLimtList.includes(val)
    },
    getYearList(y) {
      for (let i = 2021; i <= y; i++) {
        this.yearList.push(i)
      }
    },

    _exportPayToExcel() {
      window.location = api._exportPayToExcel({
        ...this.form,
        hope_pay_time_from: this.fdate(this.form.hope_pay_time[0]) || '',
        hope_pay_time_to: this.fdate(this.form.hope_pay_time[1]) || '',
        pay_time_from: this.fdate(this.form.pay_time[0]) || '',
        pay_time_to: this.fdate(this.form.pay_time[1]) || '',
        mType: '1',
      })
    },

    exportPayToExcel() {
      window.location = api.exportPayToExcel({
        ...this.form,
        hope_pay_time_from: this.fdate(this.form.hope_pay_time[0]) || '',
        hope_pay_time_to: this.fdate(this.form.hope_pay_time[1]) || '',
        pay_time_from: this.fdate(this.form.pay_time[0]) || '',
        pay_time_to: this.fdate(this.form.pay_time[1]) || '',
        mType: '1',
      })
    },

    dateValue(dateArr) {
      if (Array.isArray(dateArr)) {
        return this.fdate(dateArr[0]) + '-' + this.fdate(dateArr[1])
      } else {
        return ''
      }
    },

    check(key) {
      return this.checkList.includes(key)
    },

    link(url) {
      this.$router.push(url)
    },

		async getServiceTileList() {
      this.$fly
        .post("ApiAdministrative_serviceTypeDropdownList.html", {
          mType: 1
        })
        .then(res => {
          this.ServiceTileList = res
          console.log(this.ServiceTileList);

        });
    },

    editClick(item) {
      if (item.pay_check_status == '2') {
        this.$message.error('支付计划审核中!')
        return false
      }
      if (item.projectPayArr.budget_status == '2') {
        this.$message.error('预算审核中!')
        return false
      }
      this.$router.push({
        path: '/pay/add',
        query: {
          id: item.projectPayArr.id,
          cid: item.projectPayArr.project_id,
        },
      })
    },

    delClick(item) {//删除支付
      this.currDel = item
      if (this.currDel.projectPayArr.budget_status == '3') {
        this.$message.error('已审核的支付申请不可删除!')
        return false
      }
      this.delShow = true
    },

    handleDel() {
      this.$fly
        .post('apiProject_delPay.html', {
          pay_id: this.currDel.pay_id
        })
        .then(() => {
          this.delShow = false
          this.getList()
        })
    },

    applyPayClick(item) {
      this.currToPay = item
      if (this.currToPay.projectPayArr.budget_status != '3') {
        this.$message.error('请等待预算审核通过!')
        return false
      }
      if (!this.currToPay.projectPayArr.vendorArr) {
        this.$message.error('请选择供应商!')
        return false
      }
      if (this.currToPay.projectPayArr.pay_type == '2' && this.currToPay.projectPayArr.hope_pay_time == '0000-00-00') {
        this.$message.error('请先完善预支的计划支付时间!')
        return false
      }
      const status = this.currToPay.pay_check_status;
      if (status == '2') {
        this.$message.error('请勿重复申请!')
        return false
      }
      else if (status == '3') {
        this.$message.error('该支付计划审核已通过！')
        return false
      }
      else if (status == '4') {
        this.$message.error('该支付计划审核不通过，请修改计划重新提交!')
        return false
      }
      this.payShow = true
      this.payForm = {
        plan_id: item.id,
        hope_pay_time: item.hope_pay_time,
        plan_amount: antiThousands(item.plan_amount),
        apply_amount: antiThousands(item.plan_amount),
      }
    },

    handleApply() {
      //预支特殊情况
      if (this.currToPay.plan_name == '结算') {
        if (this.currToPay.projectPayArr.planList[0].pay_status != '3') {
          this.$message.error('请先等待预支完成支付')
          return false
        }
      }
      this.$fly
        .post('apiProject_updatePayPlan.html', {
          ...this.payForm
        })
        .then(() => {
          this.payShow = false
          this.getList()
        })
    },

    budgetCheckClick(item) {
      this.currbudgetCheck = item
      const status = this.currbudgetCheck.projectPayArr.budget_status;
      if (status == '1' || status == '0') {
        this.$message.error('本条记录还未提交审核!')
        return false
      }
      if ((status == '3' || status == '4') && this.level != '1') {
        this.$message.error('本条记录已审核!')
        return false
      }
      this.bugetCheckForm.pay_id = item.pay_id
      this.budgetCheckShow = true
    },

    handleBudgetCheck() {
      let temp = JSON.parse(JSON.stringify(this.bugetCheckForm))
      delete temp.pay_type
      this.$fly
        .post('apiProject_addUpdatePay.html', {
          ...temp
        })
        .then(() => {
          this.budgetCheckShow = false
          this.getList()
        })
    },

    payCheckClick(item) {
      this.currPayCheck = item
      if (this.currPayCheck.projectPayArr.budget_status != '3') {
        this.$message.error('请等待预算审核通过!')
        return false
      }
      if (item.pay_check_status == '1') {
        this.$message.error('此支付计划未申请!')
        return false
      }
      if ((item.pay_check_status == '3' || item.pay_check_status == '4') && this.level != '1') {
        this.$message.error('此支付计划已审核!')
        return false
      }
      this.payCheckShow = true
      this.payCheckForm = { plan_id: item.id, pay_check_status: '4', pay_check_reason: '', pay_check_info: '', }
    },

    handlePayCheck() {
      this.$fly
        .post('apiProject_updatePayPlan.html', {
          ...this.payCheckForm,
          apply_amount: '',
        })
        .then(() => {
          this.payCheckForm.pay_check_status = '4' //还原审核状态
          this.payCheckForm.pay_check_info = '' //还原审核状态
          this.payCheckForm.pay_check_reason = '' //还原审核状态
          this.payCheckShow = false
          this.getList()
        })
    },

    updatePayClick(item) {
      if (item.pay_check_status != '3') {
        this.$message.error('暂无可以更新的支付计划!')
        return false
      }
      this.$router.push({
        path: '/project/pay',
        query: {
          id: item.pay_id,
          cid: item.projectPayArr.project_id,
          planid: item.id
        },
      })
    },

    viewClick(item) {
      this.$router.push({
        path: '/pay/view',
        query: {
          id: item.projectPayArr.id,
          cid: item.projectPayArr.project_id,
        },
      })
    },

    showWrongFn(word) {
      this.$message.error(word)
    },

    applySearch() {
      let from = parseInt(this.form.apply_amount_from)
      let to = parseInt(this.form.apply_amount_to)
      if (from > to && !isNaN(from) && !isNaN(to)) {
        this.form.apply_amount_to = from
        this.form.apply_amount_from = to
      }
      store.commit('setPayData', JSON.parse(JSON.stringify(this.form)))
      this.search()
    },

    invoiceSearch() {
      let from = parseInt(this.form.invoice_amount_from)
      let to = parseInt(this.form.invoice_amount_to)
      if (from > to && !isNaN(from) && !isNaN(to)) {
        this.form.invoice_amount_to = from
        this.form.invoice_amount_from = to
      }
      store.commit('setPayData', JSON.parse(JSON.stringify(this.form)))
      this.search()
    },

    search() {
      this.p = 1
      store.commit('setPayData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },


    getStoreFn() {
      this.form = Object.keys(store.state.payData).length != 0 ? store.state.payData : this.form
      this.getList()
    },

    getList() {
      this.checkUrlFn()
      this.checkNodeFn('61')
      const hope_pay_time = this.form.hope_pay_time || []
      const pay_time = this.form.pay_time || []
      const postData = {
        ...this.form,
        p: this.p,
        per_page: this.perPage,
        hope_pay_time_from: this.fdate(hope_pay_time[0]),
        hope_pay_time_to: this.fdate(hope_pay_time[1]),
        pay_time_from: this.fdate(pay_time[0]),
        pay_time_to: this.fdate(pay_time[1]),
        [this.form.atype]: this.form.key,//搜索
      }
      api.getPayPlanList(postData).then((res) => {
        this.itemList = res.itemList
        this.itemList = this.itemList.map((item) => {
          item.plan_amount = thousands(Number(item.plan_amount))
          item.remainingBudget = thousands(Number(item.remainingBudget))
          item.projectPayArr ? item.projectPayArr.budget = thousands(Number(item.projectPayArr.budget)) : ''
          item.projectPayArr ? item.projectPayArr.cost = thousands(Number(item.projectPayArr.cost)) : ''
          item.projectPayArr ? item.projectPayArr.vendorTotalInvoice = thousands(Number(item.projectPayArr.vendorTotalInvoice)) : ''
          item.projectPayArr ? item.projectPayArr.vendorTotalUnInvoice = thousands(Number(item.projectPayArr.vendorTotalUnInvoice)) : ''
          return item
        })
        this.total = +res.totalNum
        setTimeout(() => {
          //权限
          this.level = store.state.level
          this.realName = store.state.realName
        }, 200);
      })
    },
    getPlanStatic() {
      const hope_pay_time = this.form.hope_pay_time || []
      const pay_time = this.form.pay_time || []
      const postData = {
        ...this.form,
        p: this.p,
        per_page: this.perPage,
        hope_pay_time_from: this.fdate(hope_pay_time[0]),
        hope_pay_time_to: this.fdate(hope_pay_time[1]),
        pay_time_from: this.fdate(pay_time[0]),
        pay_time_to: this.fdate(pay_time[1]),
        [this.form.atype]: this.form.key,//搜索
        mType: '1'
      }
      api.getPlanStatic(postData).then((res) => {
        this.total_item = res.itemList
        this.total_item.total_budget = thousands(Number(this.total_item.total_budget))
        this.total_item.total_cost = thousands(Number(this.total_item.total_cost))
        this.total_item.total_plan_amount = thousands(Number(this.total_item.total_plan_amount))
        this.total_item.total_vendor_invoice = thousands(Number(this.total_item.total_vendor_invoice))
        this.total_item.total_vendor_uninvoice = thousands(Number(this.total_item.total_vendor_uninvoice))
        this.total_item.total_paid_amount = thousands(Number(this.total_item.total_paid_amount))
        this.total_item.total_unpaid_amount = thousands(Number(this.total_item.total_unpaid_amount))
      })
    },
    removeTag(tag) {
      if (tag.val === 'apply_amount') {
        this.form.apply_amount_from = undefined
        this.form.apply_amount_to = undefined
      } else if (tag.val === 'invoice_amount') {
        this.form.invoice_amount_from = undefined
        this.form.invoice_amount_to = undefined
      } else if (tag.val === 'pay_time') {
        this.form.pay_time = ['', '']
      } else if (tag.val === 'hope_pay_time') {
        this.form.hope_pay_time = ['', '']
      }
      !{
        type: () => {
          this.form['key'] = undefined
        },
      }[tag.val]?.()
      this.form[tag.val] = ''
      this.form.key = this.form.atype == '' ? '' : this.form.key
      store.commit('setPayData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
    handleCurrentChange(p) {
      this.p = p

      store.commit('setPayData', JSON.parse(JSON.stringify(this.form)))
      this.getList()
    },
  },
}
</script>

<style lang="scss" scoped>
.none {
  pointer-events: none;
  opacity: 0;
}

.imgwrap {
  width: 200px;
  height: 100px;
}

.tips {
  background-color: rgba(#a6aede, 0.2);
  box-shadow: 0px 2px 6px 0px rgba(0, 0, 0, 0.1);
  border-radius: 6px;
  color: #9c9a9a;
  padding: 20px;
  font-size: 14px;

  p {
    padding-bottom: 10px;
  }
}

.flist {
  display: flex;
}

.info {
  @extend %box;
  border-bottom: 20px;
  margin-bottom: 20px;

  ul {
    @extend %center;
    flex-flow: row nowrap;
    padding: 76px 0 18px 0;

    li {
      flex: auto;
      position: relative;
      height: 90px;

      div {
        position: absolute;
        top: -50px;
        color: #9c9a9a;
        font: 16px/1 $font;

        &.lic {
          transform: translateX(50%);
          width: 100%;
          min-width: 135px;

          &::after {
            content: '';
            width: 135px;
            height: 30px;
            position: absolute;
            left: calc(50% - 67px);
            top: 28px;
            background: url(../../assets/updown.png) no-repeat transparent;
          }
        }
      }

      @extend %center;

      strong {
        font: 30px/1 $font;
        padding: 10px 0 10px 0;
      }

      span {
        color: #999;
      }

      &:not(:last-child) {
        border-right: 1px solid #ddd;
      }
    }
  }
}

.filterwrap {
  display: flex;
  justify-content: flex-end;
  align-items: center;
  padding: 0 0 20px 0;

  .filter {
    width: 85%;
  }

  .btnarea {
    box-sizing: border-box;
    width: 15%;
    padding: 0 20px;
    display: flex;
    justify-content: flex-end;
  }
}

.el-checkbox-group.filtergroup .el-checkbox {
  width: auto;
}

.apage {
  background: var(--bg); /* 0819修改 */
  padding: 8px;
  text-align: right;
}

.el-select {
  margin-right: 20px;
}

.el-tag {
  margin-right: 20px;
  height: 36px;
  line-height: 36px;
  border: none;
}

.form {
  @extend %box;
  padding: 30px;
  margin-bottom: 20px;
}

.table {
  @extend %box;
  padding: 30px;
}

.lower {
  @extend %start;
  padding: 20px 0;
  font: 600 14px/20px $font;

  >div {
    margin-right: 15px;
  }
}

.line {
  text-align: center;
}

.aul.ulist {
  height: 480px;
  padding: 50px 0;
  font: 14px/2 $font;
  text-align: left;

  >li {
    padding: 0 60px;
    display: flex;
    flex-flow: row nowrap;

    span {
      display: inline-block;
      width: 50%;
    }
  }

  .ulform {
    padding: 0 60px;
  }
}

.flex-box1 {
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
  align-items: center;

  .left {
    width: 80%;
  }

  .right {
    width: 20%;
  }
}

.payLayer {
  height: 800px;
}

.linkwrap {
  font-size: 12px;

  &.normal {
    color: #606266;

    a {
      color: #606266;

      &:hover {
        &::after {
          height: 0.2px;
          background-color: #606266;
        }
      }

      >span {
        font-size: 12px;
        color: #606266;
      }
    }
  }
}

.info-height {
  display: inline-block;
  max-height: 40px;
  overflow-x: hidden;
  //隐藏水平滚动条
  overflow-y: scroll;
  /* 0824修改：滚动条样式由全局 main.scss 统一接管 */
}
</style>
